import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
} from "@salestrak/ui";
import { DashboardTemplateGrid } from "#app/widgets/dashboards/settings/dashboard-template-chooser";
import type { DashboardTemplate } from "#app/widgets/dashboards/settings/dashboard-templates";

/**
 * The Start-over dialog (free dashboards, edit mode): the same template grid
 * the empty board shows, reachable while a board is already built. Picking a
 * template — or Blank — REPLACES the whole board; the host routes the
 * replacement through `restoreBoard`, so it stages for shared writers
 * (Save-for-team / Save-for-just-me / Discard still decide the destination)
 * and lands in the fork for personalizing viewers. Undo-able via the board
 * history like any other edit.
 */
export function DashboardStartOverDialog({
  open,
  onOpenChange,
  onSelectTemplate,
  onClearBoard,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectTemplate: (template: DashboardTemplate) => void;
  onClearBoard: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPopup size="2xl">
        <DialogHeader>
          <DialogTitle>Start over</DialogTitle>
          <DialogDescription>
            Replace everything on this dashboard with a template, or clear it to a
            blank page. Nothing changes for anyone else until you save.
          </DialogDescription>
        </DialogHeader>
        {/* DialogPanel owns the body gutters — a bare grid sits flush against
            the popup's edges. */}
        <DialogPanel>
          <DashboardTemplateGrid
            onSelectTemplate={onSelectTemplate}
            escapeTile={{
              icon: "rotate-ccw",
              label: "Blank dashboard",
              description: "Clear every widget and build from an empty grid.",
              onClick: onClearBoard,
            }}
          />
        </DialogPanel>
      </DialogPopup>
    </Dialog>
  );
}
